import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import IconButton, { type IconButtonProps } from "@mui/material/IconButton";
import InputAdornment, {
  type InputAdornmentProps,
} from "@mui/material/InputAdornment";
import Tooltip, { type TooltipProps } from "@mui/material/Tooltip";
import { type ReactNode } from "react";

export interface InfoAdornmentProps {
  tooltip: ReactNode;
  tooltipProps?: Omit<TooltipProps, "title">;
  inputAdornmentProps?: Omit<InputAdornmentProps, "position">;
  iconButtonProps?: IconButtonProps;
}

export default function InfoAdornment(props: InfoAdornmentProps) {
  const { tooltip, tooltipProps, inputAdornmentProps, iconButtonProps } = props;

  return (
    <InputAdornment position="end" {...inputAdornmentProps}>
      <Tooltip arrow title={tooltip} {...tooltipProps}>
        <IconButton edge="end" tabIndex={-1} {...iconButtonProps}>
          <InfoOutlinedIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </InputAdornment>
  );
}
